const arraySimpleIsDifferent = (a1, a2) => {
    if (a1.length !== a2.length) return true;
    if (a1.length === 0) return false;

    let diff = false;
    a1.some(elt => {
        if (a2.indexOf(elt) === -1) diff = true;
    });
    return diff;
};

const arraySimpleObjectIsDifferent = (a1, a2, property) => {
    if (a1.length !== a2.length) return true;
    if (a1.length === 0) return false;

    let diff = false;
    a1.some(elt => {
        if (a2.findIndex(elt2 => elt[property] === elt2[property]) === -1) diff = true;
    });
    return diff;
};

export default {
    arraySimpleIsDifferent,
    arraySimpleObjectIsDifferent
}